// Import the RTK Query methods from the React-specific entry point
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { addAuthenticationHeader } from '../../authentication/util';
import { IShareItem } from '../../interfaces/shares/IShareItem';

const url = (window as any).Config.ServiceBaseUrl;

// Interface for consent decision
export interface IConsentDecision {
	itemId: number;
	decision: 'keep' | 'archive' | 'migrate';
}

// Interface for user consent preferences
export interface IUserConsentPreferences {
	viewOnly: boolean;
}

export interface IUserConsents {
	decisions: IConsentDecision[];
	viewOnly: boolean;
}

// Interface for saving multiple consent decisions
export interface ISaveConsentRequest {
	userSso: string;
	decisions: IConsentDecision[];
	viewOnly: boolean;
}

// Define our single API slice object
export const ShareListAPI = createApi({
	reducerPath: 'shareListAPI',
	tagTypes: ['Shares'],
	baseQuery: fetchBaseQuery({
		baseUrl: url + '/shares',
		prepareHeaders: async  (headers) => {
			return await addAuthenticationHeader(headers);
		}
	}),
	endpoints: builder => ({
		getAllShares: builder.query<IShareItem[], string>({
			query: (user_sso: string) => `/${user_sso}`, // HINT we need this to run binded SQL query
			keepUnusedDataFor: 9000,		
			providesTags: ['Shares']
		}),
		getConsents: builder.query<IUserConsents, string>({
			query: (user_sso: string) => `/${user_sso}/consents`,
			keepUnusedDataFor: 9000,
			providesTags: ['Shares']
		}),
		saveConsent: builder.mutation<void, ISaveConsentRequest>({
			query: (consentData) => ({
				url: `/${consentData.userSso}/consents`,
				method: 'POST',
				body: { 
					decisions: consentData.decisions,
					viewOnly: consentData.viewOnly
				},
			}),
			invalidatesTags: ['Shares']
		})
	})
})

// Export the auto-generated hook
export const { useGetAllSharesQuery, useGetConsentsQuery, useSaveConsentMutation } = ShareListAPI;
